<template>
  <div class="table-container">
    <table>
        <thead>
            <tr>
                <th
                    v-for="(header, index) in headers" :key="index"

                >
                    <div class="header-cell">
                        <span>
                            {{header.label}} 
                            <!-- <span class="bold" v-if="header.value == 'total'">
                                {{totalUserCount}}
                            </span> -->
                        </span>
                        <svg @click="setSort(header)" v-if="header.sortable" width="12" height="20" viewBox="0 0 12 20" fill="none" xmlns="http://www.w3.org/2000/svg">
                            <path :class="{active:sortBy == header.value && sortDirection == 'desc'}" d="M6.60243 19.7188C6.28496 20.0794 5.75871 20.0974 5.42453 19.7549C5.41617 19.7459 5.39943 19.7278 5.39108 19.7188L0.228004 13.8231C-0.089464 13.4625 -0.0727225 12.8946 0.261454 12.552C0.420188 12.3988 0.620747 12.3086 0.837962 12.3086H11.164C11.6235 12.3086 11.9995 12.7143 11.9995 13.2101C11.9995 13.4445 11.9159 13.6609 11.7739 13.8322L6.60243 19.7188Z" fill="#B2B2B2"/>
                            <path :class="{active:sortBy == header.value && sortDirection == 'asc'}" d="M5.39757 0.281221C5.71504 -0.0793729 6.2413 -0.0974378 6.57547 0.245127C6.58383 0.254142 6.60057 0.272206 6.60892 0.281221L11.772 6.17686C12.0895 6.53746 12.0727 7.10542 11.7385 7.44799C11.5798 7.60124 11.3793 7.69141 11.162 7.69141L0.835991 7.69141C0.376498 7.69141 0.000549251 7.28574 0.000549293 6.78992C0.000549313 6.55553 0.0841098 6.33912 0.226135 6.16784L5.39757 0.281221Z" fill="#B2B2B2"/>
                        </svg>
                    </div>
                </th>
            </tr>
        </thead>
        <tbody>
            <tr 
                v-for="(invitation, i_index) in items"
                :key="i_index"
                :class="{disabled: !invitation.enabled}"
            >
                <td
                    v-for="(header, index) in headers" :key="index"
                    :class="header.class ? header.class : ''"
                >
                    <div class="cell tools-cell" v-if="header.isSettings" >
                        <div class="tools">
                            <div 
                                class="tool"
                                :class="{
                                    'delete-btn': option.icon == 'delete', 
                                    disabled: !invitation.enabled && option.icon == 'activate',
                                    disabled: option.icon == 'settings' && invitation.type == 'condition' && invitation.condition_values && invitation.condition_values.includes('certificate')
                                }"
                                v-for="(option, o_i) in header.options" :key="o_i" 
                                @click="performToolAction(option.icon, invitation)"
                            >
                                <svg v-if="option.icon == 'settings'" width="21" height="22" viewBox="0 0 21 22" fill="none" xmlns="http://www.w3.org/2000/svg">
                                    <path fill-rule="evenodd" clip-rule="evenodd" d="M10.1782 7C8.10716 7 6.42823 8.67893 6.42823 10.75C6.42823 12.8211 8.10716 14.5 10.1782 14.5C12.2493 14.5 13.9282 12.8211 13.9282 10.75C13.9282 8.67893 12.2493 7 10.1782 7ZM7.92823 10.75C7.92823 9.50736 8.93559 8.5 10.1782 8.5C11.4209 8.5 12.4282 9.50736 12.4282 10.75C12.4282 11.9926 11.4209 13 10.1782 13C8.93559 13 7.92823 11.9926 7.92823 10.75Z" fill="#4D4D4D"/>
                                    <path fill-rule="evenodd" clip-rule="evenodd" d="M10.153 2.741e-07C9.7085 -7.05727e-06 9.33746 -1.31968e-05 9.03285 0.0207703C8.71575 0.0424059 8.41622 0.0890488 8.12583 0.209332C7.45201 0.48844 6.91665 1.02379 6.63755 1.69762C6.49224 2.04842 6.45289 2.41812 6.43786 2.81996C6.42578 3.14299 6.26276 3.41251 6.02217 3.55141C5.78159 3.69031 5.46667 3.69673 5.18089 3.54568C4.82536 3.35777 4.48551 3.20699 4.10906 3.15743C3.38595 3.06223 2.65464 3.25819 2.07601 3.70219C1.82665 3.89353 1.63649 4.1296 1.45921 4.3934C1.2889 4.64681 1.10339 4.96815 0.881164 5.35307L0.855909 5.39681C0.633673 5.78172 0.44815 6.10304 0.313844 6.37723C0.174031 6.66267 0.0646616 6.94539 0.0236352 7.25701C-0.0715633 7.98012 0.12439 8.71142 0.568387 9.29005C0.799505 9.59125 1.09995 9.81016 1.44039 10.0241C1.71417 10.1961 1.8661 10.4721 1.86609 10.75C1.86607 11.0278 1.71414 11.3038 1.4404 11.4758C1.09991 11.6897 0.799429 11.9087 0.568289 12.2099C0.124292 12.7885 -0.0716613 13.5198 0.0235374 14.2429C0.0645636 14.5545 0.173933 14.8373 0.313746 15.1227C0.44805 15.3969 0.63357 15.7182 0.855801 16.1031L0.881064 16.1469C1.10329 16.5318 1.2888 16.8531 1.45911 17.1065C1.6364 17.3703 1.82655 17.6064 2.07592 17.7977C2.65455 18.2417 3.38585 18.4377 4.10896 18.3425C4.48539 18.2929 4.82522 18.1422 5.18073 17.9543C5.46655 17.8032 5.78151 17.8096 6.02213 17.9486C6.26274 18.0875 6.42578 18.357 6.43786 18.6801C6.45289 19.0819 6.49225 19.4516 6.63754 19.8024C6.91665 20.4762 7.45201 21.0116 8.12583 21.2907C8.41622 21.411 8.71575 21.4576 9.03285 21.4792C9.33746 21.5 9.7085 21.5 10.153 21.5H10.2035C10.6479 21.5 11.019 21.5 11.3236 21.4792C11.6407 21.4576 11.9402 21.411 12.2306 21.2907C12.9044 21.0116 13.4398 20.4762 13.7189 19.8024C13.8642 19.4516 13.9035 19.0819 13.9186 18.68C13.9306 18.357 14.0937 18.0875 14.3342 17.9485C14.5748 17.8096 14.8898 17.8032 15.1756 17.9542C15.5311 18.1421 15.871 18.2929 16.2474 18.3424C16.9705 18.4376 17.7018 18.2417 18.2804 17.7977C18.5298 17.6063 18.7199 17.3703 18.8972 17.1065C19.0675 16.8531 19.253 16.5318 19.4752 16.1469L19.5005 16.1031C19.7227 15.7182 19.9083 15.3968 20.0426 15.1226C20.1824 14.8372 20.2918 14.5545 20.3328 14.2429C20.428 13.5197 20.232 12.7884 19.788 12.2098C19.5569 11.9086 19.2564 11.6897 18.916 11.4758C18.6422 11.3038 18.4903 11.0278 18.4903 10.7499C18.4904 10.4721 18.6423 10.1962 18.916 10.0242C19.2565 9.8103 19.557 9.59136 19.7881 9.29012C20.2321 8.71149 20.4281 7.98019 20.3329 7.25708C20.2919 6.94546 20.1825 6.66274 20.0427 6.3773C19.9084 6.10313 19.7229 5.78183 19.5007 5.39695L19.4754 5.35318C19.2532 4.96825 19.0676 4.64688 18.8973 4.39347C18.72 4.12967 18.5299 3.8936 18.2805 3.70225C17.7019 3.25826 16.9706 3.0623 16.2475 3.1575C15.871 3.20706 15.5312 3.35782 15.1757 3.54572C14.8899 3.69679 14.5749 3.69036 14.3343 3.55144C14.0937 3.41253 13.9306 3.14297 13.9186 2.81991C13.9035 2.41808 13.8642 2.0484 13.7189 1.69762C13.4398 1.02379 12.9044 0.48844 12.2306 0.209332C11.9402 0.0890489 11.6407 0.0424059 11.3236 0.0207703C11.019 -1.31968e-05 10.6479 -7.05727e-06 10.2035 2.741e-07H10.153ZM8.69986 1.59515C8.77701 1.56319 8.89423 1.53372 9.13496 1.51729C9.38242 1.50041 9.70201 1.5 10.1782 1.5C10.6544 1.5 10.974 1.50041 11.2215 1.51729C11.4622 1.53372 11.5794 1.56319 11.6566 1.59515C11.9629 1.72202 12.2062 1.96536 12.3331 2.27165C12.3731 2.36826 12.4063 2.51887 12.4196 2.87597C12.4492 3.66835 12.8582 4.43129 13.5843 4.85048C14.3104 5.26968 15.1756 5.2424 15.8766 4.87188C16.1926 4.7049 16.3396 4.65832 16.4433 4.64467C16.7719 4.6014 17.1044 4.69047 17.3674 4.89228C17.4336 4.94312 17.5178 5.02989 17.6523 5.23016C17.7907 5.43603 17.9508 5.7126 18.1889 6.125C18.4271 6.53741 18.5865 6.81438 18.6956 7.03713C18.8017 7.25382 18.8348 7.37007 18.8457 7.45287C18.889 7.78155 18.7999 8.11397 18.5981 8.37698C18.5344 8.45995 18.4206 8.56399 18.118 8.75414C17.4466 9.17595 16.9904 9.91155 16.9903 10.7499C16.9903 11.5883 17.4465 12.324 18.1179 12.7459C18.4205 12.936 18.5344 13.04 18.598 13.123C18.7998 13.386 18.8889 13.7184 18.8456 14.0471C18.8347 14.1299 18.8016 14.2461 18.6955 14.4628C18.5864 14.6855 18.427 14.9625 18.1889 15.3749C17.9508 15.7873 17.7906 16.0639 17.6522 16.2698C17.5177 16.47 17.4335 16.5568 17.3673 16.6076C17.1043 16.8095 16.7718 16.8985 16.4432 16.8553C16.3395 16.8416 16.1925 16.795 15.8766 16.6281C15.1755 16.2575 14.3102 16.2303 13.5842 16.6495C12.8582 17.0687 12.4492 17.8316 12.4196 18.624C12.4063 18.9811 12.3731 19.1317 12.3331 19.2284C12.2062 19.5346 11.9629 19.778 11.6566 19.9049C11.5794 19.9368 11.4622 19.9663 11.2215 19.9827C10.974 19.9996 10.6544 20 10.1782 20C9.70201 20 9.38242 19.9996 9.13496 19.9827C8.89423 19.9663 8.77701 19.9368 8.69986 19.9049C8.39357 19.778 8.15023 19.5346 8.02337 19.2284C7.98335 19.1317 7.95017 18.9811 7.93682 18.624C7.90718 17.8317 7.49819 17.0687 6.77212 16.6495C6.04606 16.2303 5.18084 16.2576 4.4798 16.6281C4.16387 16.7951 4.01685 16.8417 3.91317 16.8553C3.58448 16.8986 3.25207 16.8095 2.98906 16.6077C2.92281 16.5569 2.83867 16.4701 2.70408 16.2698C2.56573 16.064 2.40558 15.7874 2.16748 15.375C1.92938 14.9626 1.76993 14.6856 1.66082 14.4629C1.55468 14.2462 1.5216 14.1299 1.5107 14.0471C1.46743 13.7184 1.5565 13.386 1.75832 13.123C1.82198 13.0401 1.93583 12.936 2.23842 12.7459C2.90981 12.3241 3.36604 11.5884 3.36609 10.7501C3.36613 9.9116 2.90988 9.17587 2.23843 8.75398C1.93591 8.56389 1.82207 8.45987 1.75842 8.37691C1.5566 8.1139 1.46753 7.78149 1.5108 7.4528C1.5217 7.37001 1.55478 7.25375 1.66092 7.03707C1.77003 6.81431 1.92948 6.53734 2.16758 6.12493C2.40568 5.71253 2.56583 5.43596 2.70418 5.23009C2.83877 5.02983 2.9229 4.94305 2.98916 4.89222C3.25217 4.6904 3.58458 4.60133 3.91327 4.6446C4.01695 4.65825 4.16398 4.70483 4.47995 4.87184C5.18096 5.24235 6.04613 5.26962 6.77217 4.85045C7.4982 4.43128 7.90718 3.66837 7.93681 2.87602C7.95017 2.51889 7.98334 2.36827 8.02336 2.27165C8.15023 1.96536 8.39357 1.72202 8.69986 1.59515Z" fill="#4D4D4D"/>
                                </svg>

                                <svg v-if="option.icon == 'mail'" width="22" height="20" viewBox="0 0 22 20" fill="none" xmlns="http://www.w3.org/2000/svg">
                                <path d="M21.7121 6.91551L11.3591 0.107324C11.2528 0.0373455 11.1278 0 11 0C10.8722 0 10.7472 0.0373455 10.6409 0.107324L0.287942 6.91551C0.199228 6.9739 0.126518 7.05301 0.0762827 7.1458C0.0260471 7.2386 -0.000157367 7.34221 7.10975e-07 7.4474V18.5107C7.10975e-07 18.9057 0.159069 19.2845 0.442212 19.5638C0.725355 19.8431 1.10938 20 1.5098 20H20.4902C20.8906 20 21.2746 19.8431 21.5578 19.5638C21.8409 19.2845 22 18.9057 22 18.5107V7.4474C22.0002 7.34221 21.974 7.2386 21.9237 7.1458C21.8735 7.05301 21.8008 6.9739 21.7121 6.91551ZM7.9998 13.4046L1.29412 18.0746V8.68671L7.9998 13.4046ZM9.32304 14.0428H12.677L19.3945 18.7235H2.60549L9.32304 14.0428ZM14.0002 13.4046L20.7059 8.68671V18.0746L14.0002 13.4046ZM11 1.4062L20.213 7.46974L12.6748 12.7663H9.3252L1.78696 7.46549L11 1.4062Z" fill="#4D4D4D"/>
                                </svg>

                                <svg v-if="option.icon == 'edit'" width="21" height="21" viewBox="0 0 21 21" fill="none" xmlns="http://www.w3.org/2000/svg">
                                        <path d="M1.30418 20.576L6.0194 19.52H6.05892C6.28027 19.5197 6.49939 19.4758 6.70373 19.3907C6.90806 19.3057 7.09359 19.1812 7.24966 19.0243L20.1639 6.11973C20.483 5.79945 20.6621 5.3659 20.6621 4.91396C20.6621 4.46202 20.483 4.02848 20.1639 3.70819L17.2911 0.829893C16.9706 0.511041 16.5367 0.332031 16.0844 0.332031C15.6322 0.332031 15.1983 0.511041 14.8778 0.829893L1.95588 13.7422C1.79759 13.9008 1.67329 14.09 1.59056 14.2982C1.50782 14.5064 1.46837 14.7293 1.47463 14.9532L0.41304 19.6861C0.391338 19.7923 0.391338 19.9018 0.41304 20.0079C0.433849 20.1044 0.473661 20.1958 0.530161 20.2767C0.58666 20.3577 0.658718 20.4266 0.742132 20.4794C0.862347 20.5554 1.00149 20.5963 1.14377 20.5973C1.19859 20.5983 1.25332 20.5922 1.30654 20.579M15.6262 1.57834C15.7478 1.45743 15.9123 1.38954 16.0838 1.38954C16.2554 1.38954 16.4199 1.45743 16.5415 1.57834L19.4149 4.45605C19.4758 4.5152 19.5242 4.58603 19.5572 4.6643C19.5901 4.74258 19.6069 4.82669 19.6065 4.9116C19.6064 4.99697 19.5894 5.08147 19.5565 5.16025C19.5236 5.23904 19.4755 5.31055 19.4149 5.37069L18.1699 6.61477L14.3776 2.82537L15.6262 1.57834ZM3.05168 14.1435L13.6286 3.57205L17.4209 7.36146L6.8439 17.9329L3.05168 14.1435ZM2.02665 17.3471L2.52619 15.1159L5.88081 18.468L3.48162 19.0031L2.02665 17.3471Z" fill="#4D4D4D"/>
                                </svg>
                                <svg v-if="option.icon == 'eye'" width="20" height="13" viewBox="0 0 20 13" fill="none" xmlns="http://www.w3.org/2000/svg">
                                    <path fill-rule="evenodd" clip-rule="evenodd" d="M1.53746 6.5C3.64222 9.64091 6.68351 11.5556 10 11.5556C13.3159 11.5556 16.3504 9.64152 18.4621 6.49937C16.3574 3.35884 13.3163 1.44444 10 1.44444C6.68351 1.44444 3.64222 3.35909 1.53746 6.5ZM0.112049 6.10746C2.41702 2.42249 5.97035 0 10 0C14.0296 0 17.583 2.42249 19.888 6.10746C20.0376 6.34665 20.0373 6.65456 19.8873 6.89351C17.5753 10.5769 14.0302 13 10 13C5.97035 13 2.41702 10.5775 0.112049 6.89254C-0.0373498 6.6537 -0.0373498 6.3463 0.112049 6.10746Z" fill="#4D4D4D"/>
                                    <path fill-rule="evenodd" clip-rule="evenodd" d="M10.001 4.33333C8.84509 4.33333 7.90801 5.30338 7.90801 6.5C7.90801 7.69662 8.84509 8.66667 10.001 8.66667C11.157 8.66667 12.0941 7.69662 12.0941 6.5C12.0941 5.30338 11.157 4.33333 10.001 4.33333ZM6.51267 6.5C6.51267 4.50564 8.07446 2.88889 10.001 2.88889C11.9276 2.88889 13.4894 4.50564 13.4894 6.5C13.4894 8.49436 11.9276 10.1111 10.001 10.1111C8.07446 10.1111 6.51267 8.49436 6.51267 6.5Z" fill="#4D4D4D"/>
                                </svg>
                                <svg class="toggle-btn" v-if="option.icon == 'activate'" width="16" height="18" viewBox="0 0 16 18" fill="none" xmlns="http://www.w3.org/2000/svg">
                                    <path d="M8.00007 2.37109C12.4202 2.37109 16 5.86787 16 10.1854C16 14.503 12.4202 17.9997 8.00007 17.9997C3.57993 17.9997 0 14.503 0 10.1854C0.0115108 5.87912 3.59145 2.38234 8.00007 2.37109ZM8.00007 16.3582C11.4878 16.3582 14.3195 13.5922 14.3195 10.1854C14.3195 6.77861 11.4878 4.01265 8.00007 4.01265C4.51231 4.01265 1.68067 6.77861 1.68067 10.1854C1.69218 13.5922 4.51231 16.3469 8.00007 16.3582Z" fill="#4D4D4D"/>
                                    <path d="M8.00628 8.62384C7.54585 8.62384 7.16602 8.25282 7.16602 7.80308V0.820763C7.16602 0.371018 7.54585 0 8.00628 0C8.46671 0 8.84654 0.371018 8.84654 0.820763V7.80308C8.84654 8.25282 8.47822 8.62384 8.00628 8.62384Z" fill="#4D4D4D"/>
                                </svg>
                                <svg v-if="option.icon == 'delete'" width="16" height="20" viewBox="0 0 16 20" fill="none" xmlns="http://www.w3.org/2000/svg">
                                    <path d="M10.0416 19.06H5.82927C3.63232 19.06 1.84692 17.3025 1.84692 15.1398V4.08232H14.0239V15.1339C14.0239 17.2965 12.2385 19.054 10.0416 19.054V19.06ZM2.75475 15.1398C2.75475 16.808 4.13465 18.1663 5.82927 18.1663H10.0416C11.7362 18.1663 13.1161 16.808 13.1161 15.1398V4.97597H2.75475V15.1398Z" fill="#D45454"/>
                                    <path d="M13.8968 4.98795C13.8484 4.98795 13.794 4.98794 13.7455 4.98199H2.089C1.6714 4.98199 1.27801 4.82113 0.98145 4.53516C0.684893 4.24323 0.521484 3.85598 0.521484 3.4449C0.521484 2.59891 1.22354 1.90781 2.08295 1.90781H13.7879C13.8303 1.90781 13.8968 1.90781 13.9695 1.90781H14.036C14.9015 1.99718 15.5309 2.74785 15.4462 3.59384C15.4038 4.00492 15.2041 4.3743 14.8834 4.63644C14.5989 4.86879 14.2539 4.98795 13.8908 4.98795H13.8968ZM2.08295 2.80147C1.71982 2.80147 1.42931 3.08744 1.42931 3.4449C1.42931 3.61767 1.49589 3.77853 1.62298 3.90364C1.75008 4.02875 1.91349 4.09429 2.089 4.09429H13.794C14.0179 4.11216 14.1813 4.05854 14.3205 3.9513C14.4536 3.83811 14.5384 3.68321 14.5565 3.51639C14.5928 3.15893 14.3266 2.84317 13.9634 2.80743C13.8847 2.80743 13.8545 2.80743 13.8242 2.80743H2.089L2.08295 2.80147Z" fill="#D45454"/>
                                    <path d="M10.671 2.79549H5.1938L5.07881 2.51547C5.00618 2.33079 4.96381 2.13418 4.96381 1.93758C4.96381 1.09158 5.66587 0.400489 6.52528 0.394531H9.32745C10.1929 0.394531 10.895 1.08563 10.895 1.93758C10.895 2.13418 10.8587 2.33079 10.786 2.51547L10.671 2.79549ZM5.8777 1.90183H9.98714C9.96898 1.56224 9.67848 1.28819 9.3335 1.28819H6.53133C6.18636 1.28819 5.89585 1.56224 5.8777 1.90183Z" fill="#D45454"/>
                                    <path d="M5.19982 16.0693C4.95168 16.0693 4.74591 15.8667 4.74591 15.6224V6.82292C4.74591 6.57865 4.95168 6.37609 5.19982 6.37609C5.44796 6.37609 5.65374 6.57865 5.65374 6.82292V15.6224C5.65374 15.8667 5.44796 16.0693 5.19982 16.0693Z" fill="#D45454"/>
                                    <path d="M7.93541 16.0693C7.68727 16.0693 7.4815 15.8667 7.4815 15.6224V6.82292C7.4815 6.57865 7.68727 6.37609 7.93541 6.37609C8.18355 6.37609 8.38933 6.57865 8.38933 6.82292V15.6224C8.38933 15.8667 8.18355 16.0693 7.93541 16.0693Z" fill="#D45454"/>
                                    <path d="M10.671 16.0693C10.4229 16.0693 10.2171 15.8667 10.2171 15.6224V6.82292C10.2171 6.57865 10.4229 6.37609 10.671 6.37609C10.9192 6.37609 11.1249 6.57865 11.1249 6.82292V15.6224C11.1249 15.8667 10.9192 16.0693 10.671 16.0693Z" fill="#D45454"/>
                                </svg>
                            </div>
                        </div>
                    </div>
                    <div class="cell" v-else-if="header.value=='condition'">
                        <div class="groups" v-if="invitation.type=='groups'">
                            <div 
                                class="bubble" 
                                v-for="(group, g_index) in invitation.condition.slice(0, maxBubblesInRow)"
                                :key="g_index"
                                :class="[group.color_id ? 'gc-'+group.color_id : 'gc-1', group.id == 0 ? 'all' : '']"
                            >
                                <span v-if="group.id != 0">
                                    {{group.name ? group.name[0].toUpperCase() : ''}}
                                </span>
                                <span v-else>
                                    A
                                </span>
                                
                            </div>
                            <span class="extra-groups" v-if="invitation.condition.length > maxBubblesInRow">
                                ...+{{ invitation.condition.length -maxBubblesInRow }}
                            </span>
                        </div>
                        <div class="users" v-if="invitation.type=='single'">
                            {{getUserSingleInvitationLabel(invitation.condition)}}
                        </div>
                        <div class="condition" v-if="invitation.type=='condition'">
                            <div class="tag" v-for="(tag, t_index) in invitation.condition" :key="t_index">
                                {{tag}}
                            </div>
                        </div>
                        <div class="link" v-if="invitation.type=='link'">
                            {{invitation.condition ? toLocal('user_side.deactivate_after')+' '+invitation.condition : toLocal('invitations.valid_indefinitely')}} 
                        </div>
                    </div>
                    <div class="cell" :class="header.tdClass ? header.tdClass : ''" v-else>
                        <CheckBox
                            v-if="header.value == 'created_at' && type == 'training'"
                            :id="'invitation_'+invitation.id"
                            :value="invitation.checked ? true : false"
                            @input="setChecked(invitation, $event)"
                            :label="''"
                            theme="gray"
                        />
                        <span>
                            {{getInvitationCellValue(invitation, header)}}
                        </span>
                    </div>
                </td>
            </tr>

        </tbody>
    </table>
  </div>
</template>

<script>
import CheckBox from '@/components/layout/inputs/CheckBox'

export default {
    props:{
        invitations: Array,
        type: String
    },
    components:{
        CheckBox
    },
    data(){
        return{
            headers:[
                {label: this.toLocal('invitations.assign_date'), value: 'created_at', sortable:true, tdClass: [this.type == 'training' ? '' : 'center']},
                {label: this.toLocal('invitations.assign_type'), value: 'type', sortable:true, class:['tag']},
                {label: this.toLocal('invitations.added_count'), value: 'user_count', sortable:true, tdClass: ['center']},
                {label: this.toLocal('invitations.add_condition'), value: 'condition'},
                {label: '', value: 'total', isSettings:true, options:[
                    {icon:'settings'},
                    {icon: 'mail'},
                    {icon: 'edit'},
                    {icon:'eye'},
                    // {icon:'activate'},
                    {icon:'delete'},
                ]},
            ],
            invitationTypes:{
                link: this.toLocal('invitations.email_link'),
                groups: this.toLocal('invitations.by_groups'),
                single: this.toLocal('invitations.add_by_one'),
                condition: this.toLocal('invitations.add_by_condition'),
            },
            items: [],
            sortBy: 'created_at',
            sortDirection: 'desc',
            maxBubblesInRow: 10
        }
    },
    mounted(){
        this.items = this._.cloneDeep(this.invitations);
        let sort_data = localStorage.getItem('invitations_table_sort');
        if(sort_data){
            this.getSortFromStorage();
        }
        if(this.sortBy != null){
            this.sortItems();
        }
        
        
    },
    computed:{
        totalUserCount(){
            if(this.items && this.items.length > 0){
                let total_count =this.items.reduce((a,b)=>a+b.user_count, 0);
                return total_count;
            }
            else return 0;
        }
    },
    watch:{
        invitations:{
            deep:true,
            handler(){
                this.items = this._.cloneDeep(this.invitations);
                let sort_data = localStorage.getItem('invitations_table_sort');
                if(sort_data){
                    this.getSortFromStorage();
                }
                if(this.sortBy != null){
                    this.sortItems();
                }
            }
        }
    },
    methods:{
        getSortFromStorage(){
            let sort_data = localStorage.getItem('invitations_table_sort');
            if(sort_data){
                sort_data = JSON.parse(sort_data);
                if(sort_data.sortBy)
                    this.sortBy = sort_data.sortBy;
                if(sort_data.sortDirection)
                    this.sortDirection = sort_data.sortDirection;
            }
        },
        performToolAction(icon, invitation){
            switch(icon){
                case 'settings':
                    if(!(icon == 'settings' && invitation.type == 'condition' && invitation.condition_values && invitation.condition_values.includes('certificate'))){
                        this.openSettingsModal(invitation)
                    }
                    break;
                case 'mail':
                    this.viewItemEmails(invitation)
                    break;
                case 'eye':
                    this.viewItem(invitation)
                    break;
                case 'activate':
                    this.toggleItem(invitation)
                    break;
                case 'delete':
                    this.removeInvitation(invitation)
                    break;
                case 'edit':
                    this.editItem(invitation)
            }
        },
        getTableHeaderLabel(header){
            if(header.value == 'total'){
                return header.label+' 255';
            }
            else{
                return header.label
            }
        },
        openSettingsModal(item){
            this.$emit('toggleSettings',item)
        },
        getInvitationCellValue(invitation, header){
            if(header.value == 'type'){
                return  this.invitationTypes[invitation.type];
            }
            else{
                return invitation[header.value];
            }
        },
        setSort(header){
            this.sortBy = header.value;
            this.sortDirection = this.sortDirection == 'asc' ? 'desc' : 'asc';
            this.sortItems();
            localStorage.setItem('invitations_table_sort', JSON.stringify({ sortBy: this.sortBy, sortDirection: this.sortDirection }));
        },
        sortItems(){
            this.items = this._.cloneDeep(this.invitations);
            this.items = this.items.sort((a,b)=>{
                if(this.sortBy == 'created_at'){
                    return this.sortDirection == 'asc' ? new Date(a[this.sortBy]) - new Date(b[this.sortBy]) : new Date(b[this.sortBy]) - new Date(a[this.sortBy])
                }
                else if(this.sortBy == 'type'){
                    return this.sortDirection == 'asc' ?
                        a[this.sortBy].localeCompare(b[this.sortBy]) 
                        : b[this.sortBy].localeCompare(a[this.sortBy]) 
                }
                else{
                    return this.sortDirection == 'asc' ? a[this.sortBy] - b[this.sortBy] : b[this.sortBy] - a[this.sortBy];
                }
            })
        },
        getUserSingleInvitationLabel(users){
            if(users && users.length > 0 && Array.isArray(users))
                return users.map(user => user.name+(user.last_name ? ' '+user.last_name : '')).join('|');
            else return ''
        },
        removeInvitation(item){
            this.$emit('removeItem',item)
        },
        toggleItem(item){
            this.$emit('toggleItem',item)
        },
        viewItem(item){
            this.$emit('viewItem',item)
        },
        editItem(item){
            this.$emit('editItem',item)
        },
        setChecked(invitation, checked){
            this.$set(invitation, 'checked', checked);
            let index = this.invitations.findIndex(el=>el.id == invitation.id);
            if(index != -1){
                this.$set(this.invitations[index], 'checked', checked);
            }
        },
        viewItemEmails(invitation){
            this.$emit('viewItemEmails',invitation)
        }
    }
}
</script>

<style lang="scss" scoped>
.table-container{
    display: flex;
    flex-direction: column;
    margin: 0 20px 0 40px;
    margin-top: 20px;
    overflow: auto;
    padding-bottom: 50px;
    padding-right: 20px;
}
.header-cell{
    display: flex;
    align-items: center;
    justify-content: space-between;
    border-right: 1px solid #B2B2B2;
    font-family: var(--main-site-font);
    padding-left: 8px;
    svg{
        margin: 0 8px;
    }
    .bold{
        font-weight: 600;
    }
}
table{
    color: #333;
    font-family: var(--main-site-font);
    font-size: 14px;
    border-collapse: collapse;

    thead{
        th{
            font-weight: 500;
            svg{
                path{
                    &.active{
                        fill: #7D7D7D;
                    }
                }
            }
            &:last-child{
                .header-cell{
                    border-right: none;
                }
            }
        }
    }
    tr{
        &.disabled{
            .cell{
                background: white;
                border-style: dashed;
                border-left: 0;
                border-right: 0;
            }
            td{
                &:first-child{
                    .cell{
                        border-left-style: dashed;
                    }
                }
                &:last-child{
                    .cell{
                        border-right-style: dashed;
                    }
                }
            }
           
        }
    }
    td{
       padding: 0;
        &:first-child{
            .cell{
                border-left: 1px solid #CACACA;
                border-top-left-radius: 8px;
                border-bottom-left-radius: 8px;
            }
        }
        &:last-child{
            .cell{
                border-right: 1px solid #CACACA;
                border-top-right-radius: 8px;
                border-bottom-right-radius: 8px;
            }
        }
        
    }
    .cell{
        background: #F4F4F4;
        border-top: 1px solid #CACACA;
        border-bottom: 1px solid #CACACA;
        display: flex;
        align-items: center;
        padding: 10px 8px;
        min-height: 54px;
        margin-top: 12px;
        &.center{
            justify-content: center;
        }
        .users{
            white-space: nowrap;
            overflow: hidden;
            text-overflow: ellipsis;
            max-width: 380px;
        }
        .condition{
            display: flex;
            align-items: center;
            gap: 8px;
            max-width: 26rem;
            .tag{
                padding: 2px 8px;
                background: white;
                border-radius: 4px;
                overflow: hidden;
                white-space: nowrap;
                text-overflow: ellipsis;
            }
        }
      
    }
}
.tag{
    .cell{
        span{
            padding: 2px 8px;
            border-radius: 4px;
            background: #FFF;
            white-space: nowrap;
            text-overflow: ellipsis;
            overflow: hidden;
        }
    }
}
.tools-cell{
    display: flex;
    justify-content: flex-end;
    width: 100%;
}
.tools{
    display: flex;
    align-items: center;
    justify-content: space-between;
    width: 100%;
    max-width: 170px;
}
.tool{
    display: flex;
    cursor: pointer;
    justify-content: center;
    align-items: center;
    min-width: 32px;
    min-height: 32px;
    border-radius: 50%;
    &:hover{
        border:1px solid #4D4D4D;
        background: white;
    }
    &.delete-btn{
        &:hover{
            border:1px solid #D45454;
        }
    }
    &.disabled{
        opacity: 0.5;
        cursor:not-allowed;
        .toggle-btn{
            path{
                fill: white;
            }

        }
        &:hover{
            border: none;
            background: transparent;
        }
    }
}
.groups{
    display: flex;
    align-items: center;
    .bubble{
        display: flex;
        align-items: center;
        position: relative;
        border-radius: 50%;
        height: 30px;
        width: 30px;
        box-shadow: -1px 0 2px rgba(0, 0, 0, 0.16);
        span{
            display: flex;
            align-items: center;
            justify-content: center;
            position: absolute;
            top: 0;
            right: 0;
            left: 0;
            bottom: 0;
            margin: auto;
            color: #333;
            text-align: center;
            font-family: var(--main-site-font);
            font-size: 14px;
            font-style: normal;
        }
        &:not(:first-child){
            margin-left: -8px;
        }
        &.all{
   
            background: linear-gradient(52deg,  hsl(
            (1 * 40 % 360),
            (20 + 2.5 * 1) % 70 * 1%,
            var(--theme-lightness)
            ) 0%,  hsl(
            (3 * 40 % 360),
            (20 + 2.5 * 2) % 70 * 1%,
            var(--theme-lightness)
            ) 33%,  hsl(
            (7 * 40 % 360),
            (20 + 2.5 * 3) % 70 * 1%,
            var(--theme-lightness)
            ) 66%); 
        }
    }
}
.extra-groups{
    margin-top: 4px;
}
</style>